import React from "react";
import "./App.css";

function Discografia() {
  return (
    <div>
      {/* Header  */}
      <div className="row">
        <header className="header">
          <nav className="navbar navbar-expand-lg py-3 fixed-top">
            <div className="container">
              <div className="d-flex justify-content-center align-items-center">
                <a
                  className="nav-logo m-0 mx-0 me-lg-3 p-0 text-decoration-none me-md-3"
                  href="/home">
                  HipHop
                </a>
                <img
                  src="/images/svg/cd.svg"
                  alt="cd"
                  id="cd"
                  className="m-0 px-0 d-none d-lg-block d-md-block d-sm-block"
                />
              </div>

              <button
                className=" navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon rounded rounded-1 "></span>
              </button>

              <div className="collapse navbar-collapse me-lg-3" id="navbarNav">
                <ul className="nav-ul navbar-nav mx-auto me-0 pe-3 align-items-md-center align-items-center">
                  <li className="mt-md-4 mt-sm-3 mt-4 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/home">
                      Inicio
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/videos">
                      Video clips
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/disc">
                      Discografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/bio">
                      Biografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 mt-sm-3 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/eventos">
                      Eventos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </div>

      {/* Contenido */}
      <div className="container disc position-relative z-0">
        <section className="content-disc">
          <article className="tarject-disc position-relative">
            <h1 className="text-center">Efecto dominó</h1>

            <img
              src="/images/jpg/contraportada.jpg"
              alt="Portada del álbum Efecto dominó"
              className="img-disc"
              width={200}
              height={250}
            />

            <p className="disc-description">
              Es el primer álbum de Turkano, compuesto por 8 tracks y lanzado el
              11 de enero del 2025. El álbum sobresale con canciones como "Get
              the Money", "El Dealer" y "Black Neo", y tuvo muy buena
              percepción en la escena local.
            </p>
          </article>

          <article className="tarject-disc position-relative">
            <h1>El show debe continuar</h1>

            <img
              src="/images/jpg/bio-grup.jpg"
              alt="Portada del álbum El show debe continuar"
              className="img-disc"
              width={200}
            />

            <p className="disc-description">
              Es un álbum conceptual de drama urbano y storytelling psicológico
              creado por Turkano. Más que una colección de canciones, el
              proyecto fue concebido como una experiencia interactiva donde la
              música, la narrativa y el misterio se unen para construir una
              historia que el oyente debe descubrir y descifrar.
            </p>
          </article>

          <article className="tarject-disc position-relative">
            <h1>Lo más fresco de la city</h1>

            <img
              src="/images/jpg/city.png"
              alt="Portada del álbum Lo más fresco de la city"
              className="img-disc"
              width={200}
            />

            <p className="disc-description">
              Es el próximo álbum de Turkano, con fecha de lanzamiento el 10 de
              enero del 2027.
            </p>
          </article>
        </section>
      </div>

      {/* Pie */}
      <footer className="footer">
        <div className="container d-flex flex-column align-items-center p-3 pb-0">
          <h1 className="footer-title text-center">
            Escúchanos en <br /> <span className="">Plataformas</span>
          </h1>

         <div className="footer-imgs d-flex justify-content-around w-75 mt-4">
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/youtube-f-w.svg"
                alt="YouTube"
                width="170"
                title="YouTube"
                id="img-yt"
              />
            </a>
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/yt_music-f-w.svg"
                alt="YouTube Music"
                width="80"
                title="YouTube Music"
              />
            </a>
            <a
              href="https://open.spotify.com/intl-es/artist/4xU5vqImsU2aw0egTk7p68?si=HFFGGeUcR2i29alfqrSfUg"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/spotify-f-w.svg"
                alt="Spotify"
                width="80"
                title="Spotify"
              />
            </a>
            <a
              href="https://link.deezer.com/s/33gNTeFkFpklf7NWxT4D7"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/deezer-f-w.svg"
                alt="Deezer"
                width="80"
                title="Deezer"
              />
            </a>
          </div>


          <div className="comunication w-50 d-lg-flex justify-content-around align-items-center py-3 pb-5 d-grid col-1">
            <div className="footer-contact text-center">
              <h2>Contacto</h2>
              <p>19117records@gmail.com</p>
              <p>3146148505</p>
            </div>
          </div>
        </div>

        <div className="copy d-flex justify-content-between mx-3 fs-6">
          <p>2023, &copy; TURKANO</p>
          <p className="otto text-uppercase">&copy; OTTO | Carlos Arteaga</p>
        </div>
      </footer>
    </div>
  );
}

export default Discografia;
